<template>
    <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
            <select class="form-control mb-3 text-success" id="smartMenu" v-model="smartMenu" @change="getMenu($event)">
                <option value="">Action</option>
                <option value="Orders">Manage orders</option>
                <option value="Users">Manage users</option>                
                <option value="Register">Register new user</option>
            </select>            
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                smartMenu: ''
            }            
        },
        methods: {
            getMenu(e){
                this.$router.push({name: e.target.value})
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Helpers/SelectMenu.vue